import { z } from "zod";

export const examsSearchSchema = z.object({
	status: z
		.enum(["disponiveis", "agendadas", "liberadas"])
		.catch("disponiveis"),
	name: z.string().optional(),
	year: z.string().optional().default(new Date().getFullYear().toString()),
	subject: z.string().optional(),
	category: z.number().optional(),
	page: z.number().optional().default(1),
	date: z.string().optional(),
});

export type ExamsSearch = z.infer<typeof examsSearchSchema>;
